import { http } from 'src/utils/http.util'
import {
  PlanningAllTabFormValues,
  PlanningTabFormValues,
  TPatientMedEventsByRangeOfDays,
  TPlanningPatientMedEventsRequest,
  TPlanningPatientMedEventsResponse,
} from 'src/pages/medical/planning/_components/planning.type'

export const PlanningService = {
  getPatientMedEventsList: (
    projectId: number,
    data: TPlanningPatientMedEventsRequest,
  ): Promise<TPlanningPatientMedEventsResponse> => {
    return http.post(`/projects/${projectId}/planning/list`, data).then((res) => res.data)
  },
  getPatientMedEventsByRangeOfDays: (
    projectId: number,
    tabId: number,
  ): Promise<TPatientMedEventsByRangeOfDays> => {
    return http
      .get(`/projects/${projectId}/planning/tabs/${tabId === 0 ? 'all' : tabId}/relative-range-of-days`)
      .then((res) => res.data)
  },
  postNewTab: (projectId: number, tab: PlanningTabFormValues) => {
    return http.post(`projects/${projectId}/planning/tabs`, tab).then((result) => result.data)
  },
  putPlanningTab: (projectId: number, tabId: number, tab: PlanningTabFormValues) => {
    return http.put(`projects/${projectId}/planning/tabs/${tabId}`, tab).then((result) => result.data)
  },
  putAllPlanningTab: (projectId: number, tab: PlanningAllTabFormValues) => {
    return http.put(`projects/${projectId}/planning/tabs/all`, tab).then((result) => result.data)
  },
  deletePlanningTab: (projectId: number, tabId: number) => {
    return http.delete(`projects/${projectId}/planning/tabs/${tabId}`)
  },
}
